import { render, staticRenderFns } from "./GptFloating.vue?vue&type=template&id=25452c33&scoped=true"
import script from "./GptFloating.vue?vue&type=script&lang=js"
export * from "./GptFloating.vue?vue&type=script&lang=js"
import style0 from "./GptFloating.vue?vue&type=style&index=0&id=25452c33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25452c33",
  null
  
)

export default component.exports